export default "__VITE_ASSET__af9f1610__"